import {
	ComboBoxControl,
	ComboBoxItemDisplayEnum,
	ComboBoxTypeEnum,
	FlexGap,
	StackHorizontal,
} from '@ukpostbox/frontend-framework';
import { useFormContext } from '@ukpostbox/frontend-framework/lib/ReactHookForm';
import React from 'react';
import { IncludeExclude } from '../IncludeExclude';

type SenderConditionType = {
	name: string;
	defaultValue: any;
	defaultIncludesValue: boolean;
	changeCallback: (value: any) => void;
};

function SenderCondition(props: SenderConditionType) {
	const { getValues, setValue } = useFormContext();

	return (
		<StackHorizontal gap={FlexGap.ExtraSmall}>
			<IncludeExclude name={`${props.name}.includes`} defaultValue={props.defaultIncludesValue} />

			<ComboBoxControl
				name={`${props.name}.values`}
				placeholder='Select Sender...'
				valueType='number'
				data={[]}
				defaultValue={getValues(props.name).value ? [getValues(props.name).value] : undefined}
				displayType={ComboBoxTypeEnum.Single}
				displayItemLabelType={ComboBoxItemDisplayEnum.Label}
				forwardValueCallback={(e) => setValue(props.name, e)}
			/>
		</StackHorizontal>
	);
}

export { SenderCondition };
